import {BV,setupWKWebViewJavascriptBridge} from "./index"
import store from "@/store"
import tools from '@/common/tools';
//暂停所有媒体
const pauseMedia = function() {
    let videos = document.getElementsByTagName('video');
    if (videos && videos.length > 0) {
        Array.from(videos).forEach(element => {
            element.pause();
        });
    }
    let audios = document.getElementsByTagName('audio');
    if (audios && audios.length > 0) {
        Array.from(audios).forEach(element => {
            element.pause();
        });
    }
}

/**
 * app版本记录
 * 22080100
 * 选择图片成功的回调方法由updateSuccess修改为uploadSuccess
 * 22093000
 * 添加分享和拨打电话功能
 * 23042600
 * 点击返回顶部
 * 23060800
 * 打开微信小程序
 */
/**调用原生*/

//获取app原生信息和加密的key
export function getAppInfo(){
    return new Promise(resolve=>{
        if(!tools.isYdApp()){
            store.commit('setAppInfo', {
                ClientId: "",
                RequestNowVersion: "WEB_12_OQPDA",
                RequestDigestKey: "PiArSjfSHt2hbvjDN4682bd3CMbTd6fn",
                RequestEncryptKey: "xj4wyGzQy7cWBSc2P33U68DG",
                ResponseDigestKey: "e3VG8L8RXLPj7NWqn49UkQEjXxbePmvp",
                ResponseEncryptKey: "NfwLddSEfjyCqhK3C8EWhbot"
            });
            resolve();
            return;
        }
        if (BV().ios) {
            setupWKWebViewJavascriptBridge(function (bridge) {
                if(bridge){
                    bridge.callHandler('getAppInfo', {}, function (responseData) { 
                        var data = responseData || {};
                        store.commit('setAppInfo', data);
                        resolve();
                    })
                }else{
                    resolve();
                }
            })
        } else {
            var data = JSON.parse(window?.cesyd?.getAppInfo() || '{}');
            store.commit('setAppInfo', data);
            resolve();
        }
    })
}
//获取请求需要的原生数据
export function getAppData(){
    return new Promise(resolve=>{
        if(process.env.NODE_ENV == "production"){
            if (BV().ios) {
                setupWKWebViewJavascriptBridge(function (bridge) {
                    if(bridge){
                        bridge.callHandler('getAppData', {}, function (responseData) { 
                            var data = responseData || {};
                            store.commit('setToken', data.Token);
                            resolve(data);
                        })
                    }else{
                        resolve({});
                    }
                })
            } else {
                var data = JSON.parse(window?.cesyd?.getAppData() || '{}');
                store.commit('setToken', data.Token);
                resolve(data);
            }
        }else{
            var data = {Timestamp:parseInt(new Date().getTime()/1000)};
            resolve(data);
        }
    })
}

//请求错误调用原生
export function requestError(Code){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('requestError', {Code}, function () { })
            }
        })
    } else {
        window?.cesyd?.requestError(JSON.stringify({Code}))
    }
}

//关闭WebView
export function closeWebView(Type = 0){
    pauseMedia();
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('closeWebView', {Type}, function () { })
            }
        })
    } else {
        window?.cesyd?.closeWebView(JSON.stringify({Type}));
    }
}

//调起原生登陆
export function toLogin(Type){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('toLogin', {Type}, function () { })
            }
        })
    } else {
        window?.cesyd?.toLogin(JSON.stringify({Type}));
    }
}

//重置Token
export function resetToken(SessionToken){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('resetToken', SessionToken, function () { })
            }
        })
    } else {
        window?.cesyd?.resetToken(JSON.stringify(SessionToken));
    }
}

//获取当前用户是否登录，登录类型是什么
export function getUserState(){
    return new Promise(resolve=>{
        if(process.env.NODE_ENV == "production"){
            if (BV().ios) {
                setupWKWebViewJavascriptBridge(function (bridge) {
                    if(bridge){
                        bridge.callHandler('getUserState', {}, function (responseData) { 
                            var data = responseData || {};
                            resolve(data.Type);
                        })
                    }else{
                        resolve(0);
                    }
                })
            } else {
                var data = JSON.parse(window?.cesyd?.getUserState() || '{}');
                resolve(data.Type);
            }
        }else{
            resolve(localStorage.getItem('UserType'));
        }
    })
}

//设置导航栏样式
export function setTabStyle(obj={}){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('setTabStyle', obj, function () {})
            }
        })
    } else {
        window?.cesyd?.setTabStyle(JSON.stringify(obj));
    }
}

//保存图片到本地
export function saveImage(ImgUrl){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('saveImage', {ImgUrl}, function () {})
            }
        })
    } else {
        window?.cesyd?.saveImage(JSON.stringify({ImgUrl}));
    }
}

//保存文件到本地
export function saveFile(FileUrl,FileName){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('saveFile', {FileUrl,FileName}, function () {})
            }
        })
    } else {
        window?.cesyd?.saveFile(JSON.stringify({FileUrl,FileName}));
    }
}

//选择图片
export function updatePortrait(obj){
    return new Promise(resolve=>{
        var vStr = store.state.AppInfo.RequestNowVersion;
        var v = vStr.split('_')[1];
        if (BV().ios) {
            setupWKWebViewJavascriptBridge(function (bridge) {
                if(bridge){
                    bridge.callHandler('updatePortrait', obj, function () {})

                    if(v < '22080100'){
                        bridge.registerHandler( 'updateSuccess', function (data = {}) {
                            data.Url = data.PortraitUrl;
                            resolve(data);
                        })
                    }else{
                        bridge.registerHandler('uploadSuccess', function (data = {}) {
                            resolve(data);
                        })
                    }
                }
            })
        } else {
            window?.cesyd?.updatePortrait(JSON.stringify(obj));

            if(v < '22080100'){
                window.updateSuccess = function(data = "{}"){
                    data = JSON.parse(data);
                    data.Url = data.PortraitUrl;
                    resolve(data);
                }
            }else{
                window.uploadSuccess = function(data = "{}"){
                    resolve(JSON.parse(data));
                }
            }
        }
    })
}

//使用新的webview打开地址
export function webviewOpenUrl(Url){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('webviewOpenUrl', {Url}, function () {})
            }
        })
    } else {
        window?.cesyd?.webviewOpenUrl(JSON.stringify({Url}));
    }
}

//分享
export function share(params = {}){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('share', params, function () {})
            }
        })
    } else {
        window?.cesyd?.share(JSON.stringify(params));
    }
}

//拨打电话
export function makingCalls(TelNo){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('makingCalls', {TelNo}, function () {})
            }
        })
    } else {
        window?.cesyd?.makingCalls(JSON.stringify({TelNo}));
    }
}
//打开微信小程序
export function jumpWxMiniApp(wxPageUrl){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.callHandler('jumpWxMiniApp', {wxPageUrl}, function () {})
            }
        })
    } else {
        window?.cesyd?.jumpWxMiniApp(JSON.stringify({wxPageUrl}));
    }
}

/**原生调用 */

//登录成功
export function loginSuccess(){
    return new Promise(resolve=>{
        if (BV().ios) {
            setupWKWebViewJavascriptBridge(function (bridge) {
                if(bridge){
                    bridge.registerHandler('loginSuccess', function (data = {}) {
                        resolve(data);
                    })
                }
            })
        } else {
            window.loginSuccess = function(data = "{}"){
                resolve(JSON.parse(data));
            }
        }
    })
}

//原生点击后退
export function backPage(callback){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.registerHandler('backPage', function (data, responseCallback) {
                    callback();
                    responseCallback(1);
                })
            }
        })
    } else {
        window.backPage = function(){
            callback();
            return '1';
        }
    }
}

//返回顶部
export function backTop(callback){
    if (BV().ios) {
        setupWKWebViewJavascriptBridge(function (bridge) {
            if(bridge){
                bridge.registerHandler('backTop', function (data, responseCallback) {
                    callback();
                })
            }
        })
    } else {
        window.backTop = function(){
            callback();
        }
    }
}